import { ColorPicker, Popover } from 'antd'
import style from './index.module.less'
import {
    CARD_HIGHLIGHT_COLOR, EVENT_REFRESH_LIBRARY_LIST, MAP_HIGHLIGHT_COLOR_L_2_D, MAX_Z_INDEX
} from "@/Const";
import {getImagePathWithTheme, isDarkMode, sleep} from '@/utils';
import {t} from "i18next";
import {batchCardHighlight, batchUpdateCard, getCardById, updateCard} from "@model/card";
import {getAllHighlightContent} from "@/Utility0";
import global from "@/global";

const HighlightPicker = ({ editor ,data,updateEditCardHtml}: any) => {
    const cancelHighlight = async () => {
        // 获取当前选中节点
        const { from, to } = editor.state.selection;
        try {
            const resolvedPos = editor.state.doc.resolve(from - 2);
            const currentNode = resolvedPos.node();
            if (['taskList', 'bulletList', 'orderedList'].includes(currentNode.type.name) && to === (from + currentNode.nodeSize - 6)) {
                // 若选中区域为整个list
                currentNode.attrs = { ...currentNode.attrs, blockHighlight: false }
            }
        } catch (e) {

        }
        // 重选选中区域
        await sleep(20)
        editor.chain().focus().setTextSelection({ from: from, to: to }).run()
        editor.commands.unsetHighlight();
        if (updateEditCardHtml){
            updateEditCardHtml();
        }
    }

    /**
     * 设置标注
     * @param szHexColor
     */
    const setHighlight = async (szHexColor:any)=>{
        // const { from, to } = editor.state.selection;
        global.g_isDrawCardUpdate = true;//画布上cardEdit中的更新标识
        if (isDarkMode()){
            szHexColor = MAP_HIGHLIGHT_COLOR_L_2_D[szHexColor]
        }
        const { from, to } = editor.state.selection;
        const highlightsOri = getAllHighlightContent(editor);

        const id = crypto.randomUUID();
        editor.commands.toggleHighlight({
            color: szHexColor,
            id: id,
        });
        // 重选选中区域
        await sleep(20)
        editor.chain().focus().setTextSelection({ from: from, to: to }).run()

        //这里还是得及时更新数据到库中...
        ////这里，要遍历标注，重新保存更改的...
        setTimeout(()=>{
            const highlights = getAllHighlightContent(editor);
            batchCardHighlight(highlights.content,data?.id,data.name).then(res=>{
                postMessage(EVENT_REFRESH_LIBRARY_LIST);
            });
            if (highlights.content.length > highlightsOri.content.length){
                //表示有新增？？？？？
                window.showMessageTip(t("Highlight saved"),t("Manage tags"),"manageTag",{id:id,buttonTxt1:t('Add a note')});
            }
        },200)

        if (updateEditCardHtml){
            updateEditCardHtml();
        }

        // editor.chain().focus().setTextSelection({ from: from, to: to }).run();
        /*
        //保存到数据库...--按pdf的格式。
        const highlights:any = getAllHighlightContent(editor);
        //只保存当前这个
        for (let i=0;i<highlights.content.length;i++){
            const item = highlights.content[i];
            if (item.id == id){
                //保存到数据库
                let dbHighlight:any = await getCardById(id);
                let newItem = {...item};
                newItem.type = 'cardAnno';
                newItem.name = '';
                newItem.text = newItem.content;
                newItem.comment = newItem.noteText;
                newItem.libraryId = data?.id;
                newItem.isDeleted = 0;

                if (!dbHighlight){
                    newItem.createTime = Date.now();
                }

                newItem.updateTime = Date.now();
                newItem.annoType = 'highlight'
                delete newItem.noteText;
                delete newItem.node;
                delete newItem.content;

                updateCard(newItem);
            }
        }*/

        // const selText = editor.state.doc.textBetween(from,to,'');
        // const szId = data.id + '-'+from+'-'+to;
        // let dbLibary:any = await getCardById(szId);
        // if (!dbLibary){
        //     dbLibary = {};
        // }
        //
        // const annoLibrary = {
        //     ...dbLibary,
        //     type:'cardAnno',
        //     name:dbLibary?.name,
        //     id:szId,
        //     libraryId:data.fileId,
        //     comment:anno.comment,
        //     createTime:dbAnno?.createTime || Date.now(),
        //     updateTime:Date.now(),
        //     text:anno.text,
        //     annoType:anno.type,
        //     color:anno.color,
        // }
    }

    return (
        <Popover
            arrow={false}
            placement={"bottom"}
            zIndex={MAX_Z_INDEX}
            overlayStyle={{height:'46px'}}
            align={{offset:[0,12]}}
            overlayInnerStyle={{padding:'6px'}}
            content={
                <div className={'flex-row-vertical-center'}>
                    <img className={'img-20 mr-8 ml-2 cursor-pointer'} src={getImagePathWithTheme('clear_highlight')}  onClick={cancelHighlight}/>
                    {CARD_HIGHLIGHT_COLOR.map((item) => (
                        <div
                            key={item.color}
                            style={{
                                backgroundColor: item.color,
                                width: "20px",
                                height: "20px",
                                borderRadius:'4px',
                                display: "inline-block",
                                marginRight: "7px",
                                cursor:'pointer'
                            }}
                            onClick={async () => {
                                setHighlight(item.usedColor);
                            }}
                        />
                    ))}
                </div>
            }
        >
            <div className={'flex-row-vertical-center'} onClick={(e)=>{
                setHighlight('#FCEC96');
            }}>
                <img className={'img-15'} src={getImagePathWithTheme('card_bubble_highlight_icon.svg')}/>
                <label className={'span-single-line cursor-pointer'} style={{width: '100%',marginLeft:'6px',marginTop:'1px',marginRight:'6px'}}>{t("Highlight1")}</label>
            </div>

        </Popover>
    )
}
export default HighlightPicker